import React from "react";
import { useNavigate } from "react-router-dom";
import { Compass, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export function BespokeCTA() {
  const navigate = useNavigate();
  return (
    <section id="bespoke" data-testid="bespoke-cta" className="bg-obsidian px-6 py-24 lg:px-10">
      <div className="mx-auto max-w-4xl border border-gold/20 bg-seablue/20 p-10 text-center lg:p-16">
        <Reveal>
          <Compass size={30} className="mx-auto text-gold" strokeWidth={1.3} />
          <h2 className="mt-6 font-serif text-3xl text-warmwhite lg:text-4xl">Looking for Something Specific?</h2>
          <p className="mx-auto mt-5 max-w-xl font-sans text-base leading-relaxed text-softgrey">
            Tell us what you're looking for and we'll source opportunities aligned with your requirements.
          </p>
          <button onClick={() => navigate("/bespoke-sourcing")} data-testid="bespoke-cta-btn"
                  className="group mx-auto mt-9 flex items-center gap-2 bg-gold px-8 py-3.5 font-sans text-sm font-medium tracking-wide text-obsidian transition-all hover:brightness-110">
            Start Your Bespoke Search <ArrowUpRight size={17} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </Reveal>
      </div>
    </section>
  );
}

export function FinalCTA({ content }) {
  const navigate = useNavigate();
  const h1 = content?.heading1 || "Looking for Your";
  const h2 = content?.heading2 || "Next Opportunity?";
  const body = content?.body || "Explore our curated deals or tell us exactly what you need.";
  return (
    <section data-testid="final-cta" className="grain relative overflow-hidden border-t border-gold/15 bg-obsidian px-6 py-28 lg:px-10">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-full"
           style={{ background: "radial-gradient(circle, rgba(201,162,39,0.08) 0%, transparent 70%)" }} />
      <div className="relative z-10 mx-auto max-w-3xl text-center">
        <Reveal>
          <h2 className="font-serif text-4xl leading-tight text-warmwhite lg:text-6xl">
            {h1} <span className="text-gradient-gold italic">{h2}</span>
          </h2>
          <p className="mx-auto mt-6 max-w-lg font-sans text-base text-softgrey">{body}</p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <button onClick={() => navigate("/opportunities")} data-testid="final-explore-cta"
                    className="bg-gold px-8 py-3.5 font-sans text-sm font-medium tracking-wide text-obsidian transition-all hover:brightness-110">
              Explore Opportunities
            </button>
            <button onClick={() => navigate("/bespoke-sourcing")} data-testid="final-bespoke-cta"
                    className="border border-gold/40 px-8 py-3.5 font-sans text-sm tracking-wide text-warmwhite transition-colors hover:bg-gold/10">
              Start a Bespoke Search
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
